// extracted by mini-css-extract-plugin
export default {"footer":"LfdWJz","goToIcon":"vhAMaB","circle":"yihKLY","goToArrow":"uxGr0R","titleSection":"SKBMxN","subtitleSection":"FFmHgT","subtitleText":"l6crde","section":"Ve5jlA"};